<div class="toolbar-sticky border-bottom bg-light sticky-top mb-2 d-print-m-0" id="toolbar-sticky" *transloco="let t; read: 'ime.components.help'">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a class="text-primary" [routerLink]="['/help']" (click)="help = undefined">{{t('Help')}}</a>
    </li>
    <li class="breadcrumb-item">
      <span class="text-primary">{{help?.Title}}</span>
    </li>
  </ol>
  <app-help-action-bar-buttons (saveClick)="save()" (editClick)="edit()" (getUnmodifiedClick)="getHelp(topicId, true)"></app-help-action-bar-buttons>
</div>
<div class="d-flex" *transloco="let t; read: 'ime.components.help'">
  <div style="min-width: 350px; max-width: 400px; height: calc(100vh - 6rem); overflow: auto; position: sticky; top: 3rem">
    <app-help-contents [topics]="topics$ | async" [selectedId]="topicId" (onAddTopic)="addTopic($event)"></app-help-contents>
  </div>
  <div class="col p-2" *ngIf="help">
    <div class="alert alert-warning d-flex align-items-center" role="alert" *ngIf="help.NeedsUpdate">
      <svg viewBox="0 0 8 8" class="icon me-2" inlineSVG="#exclamation-circle">
      </svg>
      {{t('This help topic may be outdated')}}
      <button type="button" class="btn btn-outline-warning ms-2" (click)="getHelp(help.Id, true)">
        {{t('View base version')}}
      </button>
    </div>
    <app-help-container *ngIf="!helpService.isEditMode"
                        [value]="help.Value"
                        [isLoading]="isLoading()"
                        (onCreate)="create()"></app-help-container>
    <ng-container *ngIf="helpService.isEditMode">
      <div class="row">
        <div class="form-group col-6">
          <input type="text" class="form-control" id="title" name="title" [(ngModel)]="help.Title">
        </div>
        <div class="col-6 d-flex align-items-center">
          <span class="ms-auto text-muted" title="{{t('Modified date')}}">{{help.UserVersionModifiedDate ?? help.CoreVersionModifiedDate | date : 'short'}}</span>
        </div>
      </div>
      <editor [apiKey]=apiKey
        [(ngModel)]="help.Value"
        [init]="{ plugins: 'lists link image media table code help',
        toolbar: 'undo redo | styles | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | image media | help',
        image_description: false,
        image_dimensions: true,
        images_upload_handler: image_upload_handler,
        image_uploadtab: true,
        media_alt_source: false,
        media_poster: false,
        height: 'calc(100vh - 10rem)'}">
      </editor>
    </ng-container>
  </div>
</div>
